module.exports = __webpack_public_path__ + "media/images/category_icons/worksheet-1a7258abbf3923a687a2dcc91536634a.svg";